import type { FieldValues } from "react-hook-form";
import { FormComponent } from "../FormComponent";
import { FormDropdown, type FormDropdownProps } from "../fields/FormDropdown";
import type { FormComponentProps } from "../types";

export type FormDropdownComponentProps<TFieldValues extends FieldValues> =
	FormComponentProps<TFieldValues> &
		Omit<FormDropdownProps<TFieldValues>, "control" | "name"> & {
			name: FormComponentProps<TFieldValues>["name"];
		};

export const FormDropdownComponent = <TFieldValues extends FieldValues>(
	props: FormDropdownComponentProps<TFieldValues>,
) => {
	const { formMethods, ...restProps } = props;
	const { control } = formMethods;
	return (
		<FormComponent {...props}>
			<FormDropdown control={control} {...restProps} />
		</FormComponent>
	);
};
